define(function (require) {
	const Marionette = require('backbone.marionette');
	const tpl = require('./templates/t_cpv_add_details.hbs');
	const itemView = require('./v_itv_add_detail');

	return Marionette.CompositeView.extend({
		initialize: function (options) {
			this.config = options.config;
			this.useDetailCollection = options.useDetailCollection;
			this.initialEnabled = options.initialEnabled;
			this.toggleEnabled = options.toggleEnabled;
			this.aggregateModel = options.aggregateModel;
			this.aggregateModelDetailPropertyId = options.aggregateModelDetailPropertyId;
			this.loadParentHansenModel = options.loadParentHansenModel;
			this.defaultExpanded = options.defaultExpanded;
		},
		childViewOptions: function () {
			return {
				config: this.config,
				isAdd: true,
				initialEnabled: this.initialEnabled,
				toggleEnabled: this.toggleEnabled,
				useDetailCollection: this.useDetailCollection,
				aggregateModel: this.aggregateModel,
				aggregateModelDetailPropertyId: this.aggregateModelDetailPropertyId,
				loadParentHansenModel:this.loadParentHansenModel,
				defaultExpanded: this.defaultExpanded
			};
		},
		onChildviewInvalid: function () {
			this.triggerMethod('invalid');
		},
		template: tpl,
		childViewContainer: function () {
			return ".list-table"
		},
		childView: itemView,
		templateHelpers: function () {
			return {};
		}
	});
});
